/**
 * A short haptic tick. Android: the Vibration API. iPhone has no web vibration API, but Safari
 * (iOS 18+) plays its own haptic when a native switch toggles, so a hidden one is flipped. iOS only
 * does it from a user gesture (a tap's handler), never from a timer. Anywhere else, nothing.
 */
export const hapticTick = (): void => {
  if (typeof window === 'undefined') return
  if (typeof navigator.vibrate === 'function') {
    navigator.vibrate(10)
    return
  }
  const label = document.createElement('label')
  label.setAttribute('aria-hidden', 'true')
  label.style.display = 'none'
  const input = document.createElement('input')
  input.type = 'checkbox'
  input.setAttribute('switch', '')
  label.appendChild(input)
  document.head.appendChild(label)
  label.click()
  label.remove()
}
